import React, { useEffect } from 'react';
import './index.css';
import Cursor from './components/Cursor';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Countdown from './components/Countdown';
import About from './components/About';
import Cities from './components/Cities';
import Speakers from './components/Speakers';
import SalvationCTA from './components/SalvationCTA';
import Register from './components/Register';
import PrayerWall from './components/PrayerWall';
import GetInvolved from './components/GetInvolved';
import Media from './components/Media';
import Merch from './components/Merch';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function App() {
  useEffect(() => {
    // Scroll reveal observer
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Cursor />
      <Nav />
      <main>
        <Hero />
        <Countdown />
        <About />
        <Cities />
        <Speakers />
        <SalvationCTA />
        <Register />
        <PrayerWall />
        <GetInvolved />
        <Media />
        <Merch />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}
